import { Component, effect, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormBuilderBase } from '@shared/components/row-edition-form/form-builder/form-builder.model';

import { unwrapValue, wrapValue } from '../row-edition-form.utils';

@Component({
  selector: 'app-boolean',
  imports: [],
  templateUrl: './boolean.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        height: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BooleanComponent),
      multi: true
    }
  ]
})
export class BooleanComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<boolean | null>();
  indeterminate = input<boolean>();
  required = input<FormBuilderBase['required']>();
  wrapperProperty = input<string | undefined>(undefined);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: boolean) => {};
  onTouched = () => {};

  constructor() {
    effect(() => {
      const value = this.value();
      this.onChange(value as boolean);
    });
  }

  onInput() {
    this.value.set(!this.value());
  }

  writeValue(value: boolean): void {
    this.value.set(unwrapValue(!!value, this.wrapperProperty()) as boolean);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = (value: boolean) => fn(wrapValue(value, this.wrapperProperty()));
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}
